import React from 'react';
import './ts-badged-image.style.scss';

export interface TsBadgedImageProps {
    isActive?: boolean;
    displayBadge?: boolean;
    displayBorder?: boolean;
    badgeValue?: string | number;
    width?: number | string;
    height?: number | string;
    url: string;
    onImageLoaded?: (event: React.SyntheticEvent<HTMLImageElement>) => void;
}

const toNumber = (value?: number | string): number => {
    if (value === undefined) {
        return 0;
    }
    if (typeof value === 'number') {
        return value;
    }
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
};

export const TsBadgedImage: React.FC<TsBadgedImageProps> = ({
    isActive,
    displayBadge,
    displayBorder,
    badgeValue,
    width,
    height,
    url,
    onImageLoaded
}) => {
    const numericWidth = toNumber(width);
    const numericHeight = toNumber(height);
    const isBadgeVisible = displayBadge === undefined || displayBadge;
    const isBorderVisible = displayBorder === undefined || displayBorder;
    const wrapperStyle: React.CSSProperties = {
        width: `${numericWidth}px`,
        height: `${numericHeight}px`
    };
    const imgStyle: React.CSSProperties =
        numericHeight >= numericWidth ? {height: `${numericHeight}px`} : {width: `${numericWidth}px`};

    return (
        <div className={`ts-badged-image${isActive ? ' active' : ''}`} style={wrapperStyle}>
            {isBadgeVisible ? <div className='image-badge'>{badgeValue}</div> : null}
            <div className={`img-wrapper${isBorderVisible ? ' img-border' : ''}`} style={wrapperStyle}>
                <img src={url} onLoad={onImageLoaded} style={imgStyle} />
            </div>
        </div>
    );
};

export default TsBadgedImage;
